export default __webpack_public_path__ + "static/media/UseMyTechStuff.371c50d3.png";